import { render, staticRenderFns } from "./TaskWorkerTransferModal.vue?vue&type=template&id=178c6df6"
import script from "./TaskWorkerTransferModal.vue?vue&type=script&lang=js"
export * from "./TaskWorkerTransferModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports